import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { profilEmprunteurTravailARisqueOptions } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'travail-risque-form',
    templateUrl: './travail-risque-form.component.html',
    styleUrls: ['./travail-risque-form.component.scss'],
    standalone: false
})
export class TravailRisqueComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionsTravailARisque: FormControlOption[] =
    profilEmprunteurTravailARisqueOptions;
  productType: string;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.productType = this.subscriptionFacade.getPledge()?.productType;
    this.subscriptionFacade.initForm(this, { productType: this.productType });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
